import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import { emailAddress, provinces } from './common-steps'
import {
  buyOrBringPhone,
  chooseBrands,
  chooseBrandsAndroid,
  chooseBrandsProprietary,
  choosePhoneCamera,
  choosePhoneFromList,
  choosePhoneMemory,
  choosePhoneOs,
  choosePhoneSize,
  currentProviderMobile,
  howManyCallingMinutes,
  howMuchData,
} from './mobile-steps'

export const buyOrBringPhoneMobileSearchEmail: ScenarioStep = {
  ...buyOrBringPhone,
  answers: [
    {
      id: 'purchase-phone',
      text: 'buy-or-bring-phone_purchase-phone',
      next: Steps.CHOOSE_PHONE_OS,
      metadata: { image: Images.PURCHASE_PHONE },
    },
    {
      id: 'byod',
      text: 'buy-or-bring-phone_byod',
      next: Steps.EMAIL_ADDRESS,
      metadata: { image: Images.BRING_PHONE },
    },
  ],
}

export const choosePhoneFromListMobileSearchEmail: ScenarioStep = {
  ...choosePhoneFromList,

  next: Steps.EMAIL_ADDRESS,
}

export const emailAddressMobileSearchEmail: ScenarioStep = {
  ...emailAddress,
  question: 'email-address-optional_question',
  tip: 'email-address-optional_tip',
  answerPlaceholder: 'email-address-optional_answerPlaceholder',
  next: Steps.DONE,
}

export const howMuchDataMobileSearchEmail: ScenarioStep = {
  ...howMuchData,
  answers: [
    { id: '0MB', text: { key: 'common_mb-amount', options: { count: 0 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '250MB', text: { key: 'common_mb-amount', options: { count: 250 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '500MB', text: { key: 'common_mb-amount', options: { count: 500 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '1000MB', text: { key: 'common_gb-amount', options: { count: 1 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '2000MB', text: { key: 'common_gb-amount', options: { count: 2 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '3000MB', text: { key: 'common_gb-amount', options: { count: 3 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '4000MB', text: { key: 'common_gb-amount', options: { count: 4 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '5000MB', text: { key: 'common_gb-amount', options: { count: 5 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '8000MB', text: { key: 'common_gb-amount', options: { count: 8 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '9000MB', text: { key: 'common_gb-amount', options: { count: 9 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '10000MB', text: { key: 'common_gb-amount', options: { count: 10 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '15000MB', text: { key: 'common_gb-amount', options: { count: 15 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '20000MB', text: { key: 'common_gb-amount', options: { count: 20 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '25000MB', text: { key: 'common_gb-amount', options: { count: 25 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '50000MB', text: { key: 'common_gb-amount', options: { count: 50 } }, next: Steps.BUY_OR_BRING_PHONE },
    { id: '100000MB', text: { key: 'common_gb-amount', options: { count: 100 } }, next: Steps.BUY_OR_BRING_PHONE },
  ],
}

export const howManyCallingMinutesMobileSearchEmail: ScenarioStep = {
  ...howManyCallingMinutes,
  next: Steps.HOW_MUCH_DATA,
}

export const choosePhoneOsMobileSearchEmail: ScenarioStep = {
  ...choosePhoneOs,
  next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS,
  answers: [
    { id: 'all', text: 'common_all' },
    { id: 'ios', text: 'common_ios', next: Steps.CHOOSE_PHONE_SIZE },
    { id: 'android', text: 'common_android', next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_ANDROID },
    { id: 'proprietary', text: 'choose-phone-os_proprietary', next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_PROPRIETARY },
  ],
}

export const chooseBrandsMobileSearchEmail: ScenarioStep = {
  ...chooseBrands,
  next: Steps.CHOOSE_PHONE_SIZE,
}

export const chooseBrandsAndroidMobileSearchEmail: ScenarioStep = {
  ...chooseBrandsAndroid,
  next: Steps.CHOOSE_PHONE_SIZE,
}

export const chooseBrandsProprietaryMobileSearchEmail: ScenarioStep = {
  ...chooseBrandsProprietary,
  next: Steps.CHOOSE_PHONE_SIZE,
}

export const choosePhoneSizeMobileSearchEmail: ScenarioStep = {
  ...choosePhoneSize,
  next: Steps.CHOOSE_PHONE_CAMERA,
}

export const choosePhoneCameraMobileSearchEmail: ScenarioStep = {
  ...choosePhoneCamera,
  next: Steps.CHOOSE_PHONE_MEMORY,
}

export const choosePhoneMemoryMobileSearchEmail: ScenarioStep = {
  ...choosePhoneMemory,
  next: Steps.CHOOSE_PHONE_FROM_LIST,
}

export const provincesStepMobileSearchEmail = {
  ...provinces,
  next: Steps.CURRENT_PROVIDER,
}

export const currentProviderMobileMobileSearchEmail: ScenarioStep = {
  ...currentProviderMobile,
  next: Steps.HOW_MANY_CALLING_MINUTES,
}

export const currentMonthlyPaymentAlertEmail: ScenarioStep = {
  id: Steps.HOW_MUCH_PAYMENT,
  group: QuestionGroup.ALERT,
  question: 'how-much-payment_question',
  tip: 'how-much-payment_tip',
  type: QuestionType.INPUT_CURRENCY,
  answerPlaceholder: 'how-much-payment_answerPlaceholder',
  next: Steps.BUY_OR_BRING_PHONE,
  answers: [],
}
